import { BASE_API_URL } from './config'

type TOptions = {
  searchParams: {
    [id: string]: string
  }
}

export const setApiUrl = (resourceEndpoint: string, options?: TOptions) => {
  const url = `${BASE_API_URL}${resourceEndpoint}`

  const hasSearchParams = !!options?.searchParams
  const searchParams = new URLSearchParams()

  if (hasSearchParams) {
    Object.entries(options.searchParams).forEach(([key, value]) => {
      searchParams.append(key, value)
    })
  }

  return `${url}${hasSearchParams ? '?' + searchParams : ''}`
}
